module.exports = __webpack_public_path__ + "static/alec-847fdea59fa04918209fa5a743cb9a06.png";